import { RATEGENIUS_NEW_APPLICATION, RG_DIRECT_MAIL } from '../../../values/sponsor';
import moment from 'moment';

/**
 * Generic Attribution
 *
 * @returns {boolean}
 */
export class Attribution {
  constructor (
    {
      autopayData,
      type,
      sponsorId,
      sponsorClickId,
      attributedAt
    }
  ) {
    this.type = 'Attribution';
    this.sponsorId = parseInt(sponsorId || RATEGENIUS_NEW_APPLICATION);
    this.sponsorClickId = sponsorClickId || null;
    this.attributedAt = (attributedAt ? moment(attributedAt) : moment()).format();
    this.autopayData = autopayData;
  }

  /**
   * Merges some of the properties from the new attribution
   *
   * @param {attribution} newAttribution
   * @return {this}
   */
  merge (newAttribution) {
    if (newAttribution.autopayData) {
      this.autopayData = { ...this.autopayData, ...newAttribution.autopayData };
    }

    return this;
  }
}

/**
 * CampaignAttribution type Attribution
 */
export class CampaignAttribution extends Attribution {
  constructor (
    {
      sponsorId,
      sponsorClickId,
      campaignId,
      attributedAt,
      timeToLive
    }
  ) {
    super({ sponsorId, sponsorClickId, attributedAt });
    this.type = 'Campaign';
    this.campaignId = campaignId || null;

    this.setTtl(timeToLive);
  }

  setTtl (timeToLive) {
    this.timeToLive = null;
    this.expiresAfter = null;

    if (timeToLive !== null || typeof timeToLive === 'undefined') {
      this.timeToLive = parseInt(timeToLive);
      this.expiresAfter = moment(this.attributedAt).add(this.timeToLive, 'day').format();
    }
  }

  /**
   * Is this campaign expired? if no ttl given it will never expire
   *
   * @returns {boolean}
   */
  isExpired () {
    return this.expiresAfter === null
      ? false
      : moment().isAfter(moment(this.expiresAfter));
  }
}

export class DirectMailAttribution extends Attribution {
  constructor (
    {
      sponsorClickId,
      attributedAt,
      lenderId
    }
  ) {
    super({ sponsorId: RG_DIRECT_MAIL, sponsorClickId, attributedAt });
    this.type = 'DirectMail';
    this.lenderId = lenderId;
  }
}
